import Component, { ComponentLoader } from '@Component';
import { eventThrottle } from '@Utility';
import InViewSrcset from '@Core/components/inViewSrcset';
import TitleCard from '@Core/components/titleCard';

const DEFAULTS = {
  cardsSelector: '[data-comp-blog-index-cards]',
  moreButtonSelector: '[data-comp-blog-index-load-more-button]',
  moreSectionSelector: '[data-comp-blog-index-load-more-section]',
  categoryIdSelector: '[data-category-id]',
  groupSlugSelector: '[data-group-slug]',
};

export default class BlogIndex extends Component {
  static selector = '[data-comp-blog-index]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    Object.assign(this.$options, DEFAULTS, options);

    this.cardsContainer = this.$container.querySelector(this.$options.cardsSelector);
    this.moreButton = this.$container.querySelector(this.$options.moreButtonSelector);
    this.moreSection = this.$container.querySelector(this.$options.moreSectionSelector);

    this.$state = {
      loading: false,
      offset: 0,
      categoryId: this.$container
        .querySelector(this.$options.categoryIdSelector)?.dataset.categoryId,
    };

    if (this.moreButton) {
      this.moreButtonTextElement = this.moreButton.querySelector('.btn__inner span');
      this.moreButtonDefaultLabel = this.moreButtonTextElement.innerText;
      this.bindMoreButton();
    }
  }

  bindMoreButton() {
    this.moreButton.addEventListener('click', eventThrottle(() => this.getMoreBlogs(), 250));
  }

  getMoreBlogs() {
    if (this.$state.loading) {
      return;
    }

    this.$state.loading = true;

    this.updateMoreButtonLabel('Loading...');

    const newOffset = this.$state.offset + 8;

    fetch(this.getUrl(newOffset))
      .then((response) => response.json())
      .then(data => {
        if (!data.more) {
          this.moreSection.style.display = 'none';
        }

        const wrapper = document.createElement('div');
        wrapper.innerHTML = data.html;
        wrapper.childNodes.forEach(node => this.renderBlogCard(node));

        this.resetMoreButtonLabel();
        this.$state.offset = newOffset;
        this.$state.loading = false;

        let searchParams;

        if (!window.location.search) {
          searchParams = new URLSearchParams(window.location.search);
          searchParams.set('page', 1);
        } else {
          searchParams = new URLSearchParams(window.location.search);
          const page = parseInt(searchParams.get('page'), 10) + 1;
          searchParams.set('page', page);
        }

        window.history.pushState(null, '', `?${searchParams}`);
      });
  }

  renderBlogCard(node) {
    this.cardsContainer.append(node);
    // eslint-disable-next-line no-new
    new TitleCard(node);
    // eslint-disable-next-line no-new
    new ComponentLoader(node, [InViewSrcset]);
  }

  updateMoreButtonLabel(newLabel) {
    requestAnimationFrame(() => {
      this.moreButtonTextElement.innerText = newLabel;
    });
  }

  resetMoreButtonLabel() {
    requestAnimationFrame(() => {
      this.moreButtonTextElement.innerText = this.moreButtonDefaultLabel;
    });
  }

  getUrl(newOffset) {
    let url = `/blog/more/${newOffset}/`;

    if (this.$state.groupSlug) {
      url = `${url}${this.$state.groupSlug}/`;
    }

    if (this.$state.categoryId) {
      url = `${url}${this.$state.categoryId}/`;
    }

    return url;
  }
}
